export default {"src":"/_next/static/media/Edge mobile.bf9684dc.gif","height":422,"width":918,"blurWidth":0,"blurHeight":0};